import { API } from "../../../backend";
import { objectToQueryString } from "../../../lib/utils";

export const getBioMetricDevicesByBranch=(userId,token,branchId)=>{
  return fetch(`${API}/biometric-devices/${userId}/${branchId}`,{
    method:'get',
    headers:{
      Accept:'application/json',
      Authorization:`Bearer ${token}`
    }
  }).then(res=>res.json()).catch(err => { console.error(err); return { error: true, message: err?.message }; })
}


export const getAllBiometricCommands=(userId,token,query)=>{
  const str = objectToQueryString(query)
  return fetch(`${API}/biometric-commands/${userId}?${str}`,{
    method:'get',
    headers:{
      Accept:'application/json',
      Authorization:`Bearer ${token}`
    }
  }).then(res=>res.json()).catch(err => { console.error(err); return { error: true, message: err?.message }; })
}


export const getBiometricCommandCount=(userId,token,query)=>{
  const str = objectToQueryString(query)
  return fetch(`${API}/biometric-commands/count/${userId}?${str}`,{
    method:'get',
    headers:{
      Accept:'application/json',
      Authorization:`Bearer ${token}`
    }
  }).then(res=>res.json()).catch(err => { console.error(err); return { error: true, message: err?.message }; })
}

export const rePushCommand=(userId,token,biometriccommandId)=>{
  return fetch(`${API}/repush-biometric-command/${userId}/${biometriccommandId}`,{
    method:'post',
    headers:{
      Accept:'application/json',
      Authorization:`Bearer ${token}`
    }
  }).then(res=>res.json()).catch(err => { console.error(err); return { error: true, message: err?.message }; })
}